import { EDITOR_AUTH_REDIRECT_KEY } from '@repo/editor/src/global/constants';
import { buildEditorUrl } from '@repo/utils/url';

export const LOCAL_STORAGE_DEBUG_MODE_KEY = 'htcDebugMode';
export const LOCAL_STORAGE_SHOW_BLOG_BANNER_KEY = 'htcShowBlogBanner';
export const LOCAL_STORAGE_SHOW_DISCORD_BANNER_KEY = 'htcShowDiscordBanner';
export const LOCAL_STORAGE_SHOW_PAYMENT_SUCCESS_QUESTIONNAIRE_KEY =
  'htcShowPaymentSuccessQuestionnaire';
export const LOCAL_STORAGE_BANNER_SEEN_PREFIX = 'htcBannerSeen';
export const LOCAL_STORAGE_FREE_TRIAL_SEEN_STATUS_KEY = 'htcFreeTrialInfoSeen';
export const LOCAL_STORAGE_LAST_ACTIVE_WORKSPACE_ID = 'lastActiveWorkspaceId';

// Signup/login actions on these pages should not re-redirect
export const NO_REDIRECT_URLS = {
  backgroundGenerator: '/tools/background-generator/app',
  backgroundRemover: '/feature/ai-background-remover',
  logoGenerator: '/tools/ai-logo-generator',
  imageVectorizer: '/feature/ai-image-vectorizer',
  vectorGenerator: '/feature/ai-text-to-vector',
  svgConverter: '/tools/svg-converter',
  [EDITOR_AUTH_REDIRECT_KEY]: buildEditorUrl(),
};

export const JAM_SCRIPT_URL =
  'https://js.jam.dev/support/1b1e4d25-3feb-48bb-af0c-1943083860b2.js';
